import React, { Component } from 'react';
import OtpInputs from '../common/otpInputs';
import cx from 'classnames';

interface Props {
  phone: string;
  email?: string;
  handleOtpChange: (otp: string) => void;
  otp: string;
  verifyOtp: () => void;
  generateOtp: (requestType: string) => void;
  isOtpWrong: boolean;
  numOfInputs: number;
  verifyOtpLoader: boolean;
  fromProfileFlow?: boolean;
  otpErrMessage?: string;
}

interface State {
  currentTime: number;
  intervalId: any;
}

class OtpModal extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      currentTime: 30,
      intervalId: 0,
    };
  }

  public timer = () => {
    const newCount = this.state.currentTime - 1;
    if (newCount >= 0) {
      this.setState({ currentTime: newCount });
    } else {
      clearInterval(this.state.intervalId);
    }
  };

  public componentDidMount = () => {
    this.setState({ intervalId: setInterval(this.timer, 1000) });
  };

  public componentWillUnmount = () => {
    clearInterval(this.state.intervalId);
  };

  public handleResendOtp = () => {
    clearInterval(this.state.intervalId);
    this.props.generateOtp('RESEND_OTP');
    this.setState({
      currentTime: 30,
      intervalId: setInterval(this.timer, 1000),
    });
  };

  public render() {
    const {
      phone,
      email = '',
      handleOtpChange,
      otp,
      verifyOtp,
      isOtpWrong,
      numOfInputs = 6,
      verifyOtpLoader = false,
      fromProfileFlow = false,
      otpErrMessage = '',
    } = this.props;
    const { currentTime } = this.state;
    const showGenerateLoader = !phone;
    return (
      <div style={{ padding: '0 14px' }}>
        {showGenerateLoader ? (
          <div className="lil-text-s-14 lil-text-grey-500">
            Please wait, OTP is generating...
          </div>
        ) : (
          <div className="lil-text-s-14 lil-text-grey-500">
            Please enter the OTP sent to{' '}
            <span className="lil-font-bold">{phone}</span>
            {email && <span className="lil-font-bold"> and {email}</span>}
          </div>
        )}
        <div className="sm:lil-block lil-flex lil-flex lil-mt-6 lil-items-center">
          <div>
            <OtpInputs
              otp={otp}
              handleChange={handleOtpChange}
              numInputs={numOfInputs}
            />
          </div>
          {!showGenerateLoader && (
            <div className="lil-text-s-14 lil-ml-6 sm:lil-ml-0 lil-text-grey-500">
              {currentTime === 0 ? (
                <span
                  className="lil-text-blue-500 lil-cursor-pointer"
                  onClick={verifyOtpLoader ? undefined : this.handleResendOtp}
                >
                  Resend OTP
                </span>
              ) : (
                <span>
                  Resend OTP in{' '}
                  <span className="lil-font-bold">{currentTime}</span> sec.
                </span>
              )}
            </div>
          )}
        </div>

        {isOtpWrong && (
          <div className="lil-text-red lil-text-s-14 lil-my-2">
            {fromProfileFlow
              ? otpErrMessage ||
                'Wrong OTP, please enter a valid OTP or something went wrong'
              : 'Wrong OTP, please enter a valid OTP'}
          </div>
        )}

        <div className="lil-flex lil-mt-6 lil-bg-blue-50 lil-p-4 sm:lil-hidden">
          <img
            src="https://assets1.cleartax-cdn.com/clearsave/images/1653563327_group18140903.svg"
            alt="icon"
          />
          <div className="lil-text-s-14 lil-text-blue-300 lil-ml-1">
            {fromProfileFlow
              ? '`As per SEBI, you need to verify yourself with an OTP shared to your contact details'
              : 'As per SEBI regulation, you need to authenticate the investment and details you have provided through OTP validation'}
          </div>
        </div>
        <div className="lil-mt-10 lil-border-b-sm lil-border-grey-400"></div>
        <div className="lil-flex lil-justify-between lil-mt-4 lil-items-center">
          <p className="lil-text-s-14">
            Need help?{' '}
            <a href="mailto:invest@cleartax.in" className="lil-font-bold">
              Email us
            </a>
          </p>
          <button
            onClick={verifyOtp}
            className={cx('lil-btn lil-btn-blue lil-text-s-14', {
              ['lil-btn-disabled']: otp.length < numOfInputs || verifyOtpLoader,
            })}
            disabled={otp.length < numOfInputs || verifyOtpLoader}
          >
            {verifyOtpLoader ? 'Verifying OTP...' : 'Verify OTP'}
          </button>
        </div>
      </div>
    );
  }
}

export default OtpModal;



// WEBPACK FOOTER //
// ./components/dashboard/otpModal.tsx